import React from 'react';

import Features from '../../../components/Features';
import { LandingCta, LandingSection, LandingSectionHeader } from '../../components';

function ApiFeaturesSection() {
  return <LandingSection soft>
    <LandingSectionHeader eyebrow="Get Instant Access To" title="Live Feed of Precious Metals Spot Prices & Exchange Rates" description="From One Simple & Free API, WebSockets and MCP Server" />
    <Features />
    <LandingCta />
  </LandingSection>;
}

export default ApiFeaturesSection;
